import { PlusOutlined } from "@ant-design/icons";
import { Card } from "antd";
import { Theme } from "api/config/chalice-types";
import { TemplateCounts } from "pages/Themes/useTemplateCounts";
import ThemeCard from "./ThemeCard";

type OnRemoveFn = (themeName: string) => void;

interface SelectedThemesGridProps {
  themes: Theme[];
  selectedThemes: string[];
  templateCounts: TemplateCounts;
  isLoadingCounts: boolean;
  onAddThemeClick: () => void;
  onRemove: OnRemoveFn;
}

const SelectedThemesGrid = ({
  themes,
  selectedThemes,
  templateCounts,
  isLoadingCounts,
  onAddThemeClick,
  onRemove,
}: SelectedThemesGridProps) => {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-4 gap-4 items-stretch">
      <Card
        hoverable
        className="cursor-pointer border-dashed border-antd-colorBorder bg-transparent h-full flex items-center justify-center"
        onClick={onAddThemeClick}
      >
        <div className="flex flex-col items-center text-antd-colorTextSecondary">
          <PlusOutlined className="text-2xl mb-2" />
          <span>Add Theme</span>
        </div>
      </Card>
      {themes
        .filter(({ name }) => selectedThemes.includes(name))
        .map((theme) => (
          <ThemeCard
            selectedThemes={selectedThemes}
            isEditing={false}
            key={theme.name}
            theme={theme}
            templateCount={templateCounts[theme.name]}
            showRemoveOption={true}
            onRemove={onRemove}
            isLoadingCount={isLoadingCounts}
            onClick={onAddThemeClick}
          />
        ))}
    </div>
  );
};

export default SelectedThemesGrid;
